module.exports = __webpack_public_path__ + "static/media/logSensorsActive.f657ab48.svg";